import { Alert, Button } from '@mantine/core';
import { IconBooks } from '@tabler/icons-react';
import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './PmsLibrary.module.css';

/** Maintenance (PMS) ▸ PMS Library adresi (menü `pmsLibrary`). */
export const PMS_LIBRARY_PATH = '/pms/library';

/**
 * Sihirbazı gemi seçili açan adres (04.11 notları P1): `/pms/library?apply=<gemi>`. Yeni
 * müşteride kütüphane kendiliğinden kurulmaz; kurulum yalnız bu düğmeyle ve sihirbazın
 * önizlemesiyle olur.
 */
export function libraryApplyPath(vesselId: string): string {
  return `${PMS_LIBRARY_PATH}?apply=${encodeURIComponent(vesselId)}`;
}

/** Adresteki `apply` gemisi; kimlik biçiminde değilse yok sayılır. */
export function readApplyVessel(search: string): string | null {
  const value = new URLSearchParams(search).get('apply');
  return value && /^[A-Za-z0-9-]{1,64}$/.test(value) ? value : null;
}

/**
 * Ofiste ekipman ağacı boş gemide uyarı ve "Set up from library" (04.11 notları P1; E2'nin
 * eksiği): düğme var olan uygulama sihirbazına götürür. Etkin gemide sihirbaz kurulumu talep
 * olarak gönderir; gemi verisini gemi sunucusu yazar (mimari belge §8).
 */
export function LibrarySetupEmpty({
  vesselName,
  href,
  onSetup,
}: {
  vesselName: string | null;
  href?: string;
  onSetup: (event: MouseEvent<HTMLAnchorElement>) => void;
}) {
  const { t } = useTranslation();
  const k = (key: string, options: Record<string, unknown> = {}) =>
    t(`pmsLibrary.setup.${key}`, options);
  return (
    <Alert
      color="yellow"
      variant="light"
      role="alert"
      className={classes.setupAlert}
      title={vesselName ? k('title', { vessel: vesselName }) : k('titleNoName')}
    >
      <p className={classes.setupText}>{k('text')}</p>
      <Button
        size="xs"
        leftSection={<IconBooks size={14} />}
        {...(href ? { component: 'a' as const, href } : {})}
        onClick={onSetup}
      >
        {k('action')}
      </Button>
    </Alert>
  );
}
